import type { TFilterPayload } from '@/creditflowresearch/domain/vo/Bondscreener';

type TFilterKey = keyof TFilterPayload;

export const EXCLUDE_FLAG_SOURCE_KEYS = {
  isCurrencyExcluded: ['excludedCurrencyIds'],
  isUseOfProceedsExcluded: ['excludedUseOfProceedsIds'],
  isLeadsExcluded: ['excludedLeadIds'],
  isTenorExcluded: ['excludedTenorFrom', 'excludedTenorTo'],
  isParentsIssuersExcluded: ['excludedIssuerIds', 'excludedParentIds'],
  isTickerExcluded: ['excludedTickerCompanyIds'],
  isAdditionalFiltersExcluded: ['excludedAdditionalFilters'],
} satisfies Partial<Record<TFilterKey, TFilterKey[]>>;

export const EXCLUDE_FLAG_KEYS = Object.keys(EXCLUDE_FLAG_SOURCE_KEYS) as (keyof typeof EXCLUDE_FLAG_SOURCE_KEYS)[];
